<template>
  <w-icon-wrapper icon-name='work-user-icon'>
    <path
      id='Pfad_55700'
      d='M23.27,17.82a12.05,12.05,0,0,0-7.208-6.17A6.43,6.43,0,0,0,18.684,6.5,6.607,6.607,0,0,0,12,0,6.607,6.607,0,0,0,5.316,6.5a6.43,6.43,0,0,0,2.622,5.15A12.05,12.05,0,0,0,.73,17.82,10.6,10.6,0,0,0,0,19.84a18.024,18.024,0,0,0,1.83,1.28,19.4,19.4,0,0,0,20.34,0A18.024,18.024,0,0,0,24,19.84,10.6,10.6,0,0,0,23.27,17.82ZM7.373,6.5a4.629,4.629,0,0,1,9.254,0,4.629,4.629,0,0,1-9.254,0ZM12,22a17.2,17.2,0,0,1-9.6-2.9A10.319,10.319,0,0,1,12,13a10.319,10.319,0,0,1,9.6,6.1A17.2,17.2,0,0,1,12,22Z'
      data-name='Pfad 55700'
      fill='currentColor'
    />
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconUser' };
</script>
